import React from 'react';
import './Profile.css';
import { Skills } from './Data';

function Profile() {
    return (
        <div className="prof-main">
            <div className="profile-bg mr-2">
                <div className="profile-contents">
                    <div className="profile-img-container items-bottom-right">
                        <img className="profile-img w-100" alt=""
                            src="https://avatars0.githubusercontent.com/u/20874960?s=460&u=3ec628cd3387088553025ef6b6094ab4ce990605&v=4" />
                    </div>
                    <div className="profile-name mt-3 mb-4">
                        <p className="h5 px-4 m-0 text-center"><b>
                            Hi 👋, I am Vaibhav </b></p>
                            
                    </div>
                   
                    <div className="mb-2">
                         <p className="h6 px-4 m-0 text-center">I am a fullstack developer with following skills:</p>
                    </div>
                    <div className="w-100">
                        <ul className="style-none">
                            {
                                Skills.map((item) => (
                                    <li key={item.key}>
                                        <span className="btn pr-2 mr-2 social-link-badge">
                                            <img alt="" className="social-link-icon" src={item.icon}></img>
                                            <p className="social-link-display-text m-0 px-2">{item.title}</p>
                                        </span>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Profile;